import { useTranslation } from 'react-i18next'

import { getDocFlowMappingTypeOptions } from '../../DocFlow.utils.mapping'

export function useUploadingTableRow({
  item,
  onClickFile,
  onOpenChangeTypeModal,
}) {
  const { t } = useTranslation()

  function handleTitleClick() {
    if (!item.uploading) {
      onClickFile?.(item.id)
    }
  }

  function handleClickChangeType() {
    onOpenChangeTypeModal({ item })
  }

  const mappingTypeOptions = getDocFlowMappingTypeOptions(t)

  return {
    handleClickChangeType,
    handleTitleClick,
    mappingTypeOptions,
  }
}
